import type {
  EmbryoChromosomeCN,
  EmbryoGenomicResult,
} from "@src/packages/cycles/hooks/useEmbryoReport";

export function expectedChromosomeCopies(
  chromosome: EmbryoChromosomeCN["chr"],
  sex: EmbryoGenomicResult["sex"],
): number {
  if (chromosome === "X") return sex === "XX" ? 2 : 1;
  if (chromosome === "Y") return sex === "XX" ? 0 : 1;
  return 2;
}

/** Keep every reported value on one zero-based scale across chart groups. */
export function copyNumberScaleMaximum(
  profile: readonly EmbryoChromosomeCN[],
): number {
  return Math.max(
    4,
    ...profile
      .map((point) => point.cn)
      .filter(Number.isFinite)
      .map(Math.ceil),
  );
}

/** Use the lab's flags; a fractional signal alone is not a new diagnosis. */
export function chromosomeCopyTone(
  point: EmbryoChromosomeCN,
  mosaicChromosomes: ReadonlySet<EmbryoChromosomeCN["chr"]>,
): "expected" | "mosaic" | "different" {
  if (mosaicChromosomes.has(point.chr)) return "mosaic";
  return point.isAbnormal ? "different" : "expected";
}
